// eslint-disable-next-line import/prefer-default-export
export const calcPlanWithDiscount = (isReset: boolean | null, discount: number): number => {
  if (isReset) {
    return 100 - (100 * discount) / 100;
  }
  return 0;
};
